import React from "react";

import PropTypes from "prop-types";

import Icons from "./Icons";

const Select = ({ value, onChange, options, className, ...rest }) => {
  const selectRef = React.useRef(null);

  const handleIconClick = () => {
    if (selectRef.current) {
      selectRef.current.focus();
    }
  };

  return (
    <div className={`relative flex items-center gap-1`}>
      <select
        value={value}
        onChange={onChange}
        {...rest}
        className={`border border-[#B4C1E4] rounded-md text-[#F4F6FB] appearance-none focus:outline-none ${className}`}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <Icons
        type="downChevron"
        width={20}
        height={20}
        onClick={handleIconClick}
        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-[#F4F6FB]"
      />
    </div>
  );
};

Select.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  className: PropTypes.string,
};

Select.defaultProps = {
  className: "",
};

export default Select;
